import { Link } from "react-router-dom";
import { Box, Button, Stack, Typography } from "@mui/material";

import { useCustomerContext } from "../../../Context/CustomerContext";

export const ThreadsOverviewTableEmpty = () => {
  const { customerOrPresentationModeCustomer: customer } = useCustomerContext();

  return (
    <Stack
      spacing={2}
      sx={{
        alignItems: "center",
        my: "70px",
      }}
    >
      <Typography variant="h1" color="inherit">
        Create your first thread
      </Typography>
      <Typography variant="body1" color="inherit">
        Use DoiT Threads to manage your team’s work on Insights.
      </Typography>
      <Box>
        <Button variant="contained" component={Link} to={`/customers/${customer.id}/optimize/insights`} sx={{ mt: 2 }}>
          Go to Insights
        </Button>
      </Box>
    </Stack>
  );
};
